import api from "@/api";
import * as types from "./mutation-types";
import { initialBannerState } from "./state";

export const actions = {
  /**
   * Method to list all banners available
   * Allows for search and pagination
   *
   * TODO: Deprecate for listSliders
   */
  async list({ commit, state }, options) {
    let response;

    // TODO: Should always be flat really
    let endpoint = "/homepage/banners/flat";

    const page = options && options.page ? options.page : 1;
    const size = state.pagination.per_page;
    let from = size * page - size;

    if (!from) {
      from = 0;
    }

    const filter = {
      size,
      from,
      sort: [
        {
          [state.sortBy.field]: {
            order: state.sortBy.direction,
          },
        },
      ],
      query: {
        bool: {
          must: [
            {
              bool: {
                should: [
                  {
                    match: {
                      title: {
                        query: state.filters.searchQuery,
                        operator: "and",
                        zero_terms_query: "all",
                        fuzziness: "AUTO",
                      },
                    },
                  },
                  {
                    match_phrase_prefix: {
                      title: {
                        query: state.filters.searchQuery,
                        slop: 50,
                      },
                    },
                  },
                ],
              },
            },
          ],
        },
      },
    };

    try {
      response = await api().post(endpoint, { filter });

      if (response) {
        const { banner } = response.data.data;

        /**
         * Need to alter objects for policies/forms/eforms/files
         */
        const formattedBanners = banner.map((bnr) => {
          if (bnr.resource && bnr.resource.current_version) {
            return {
              ...bnr,
              resource: {
                ...bnr.resource,
                title: bnr.resource.current_version.title,
              },
            };
          }
          if (bnr.resource && bnr.resource.file_name) {
            return {
              ...bnr,
              resource: { ...bnr.resource, title: bnr.resource.file_name },
            };
          }
          return { ...bnr };
        });

        commit("SET_FILTER_TOTAL", response.data.meta.filter_total);
        commit("SET_CURRENT_PAGE", page);
        commit(types.LIST_BANNERS, formattedBanners);
        return Promise.resolve(formattedBanners);
      } else {
        commit(types.LIST_BANNERS, []);
        return Promise.reject(new Error(err));
      }
    } catch (err) {
      if (err.response.status === 404 && err.response.data.data.length === 0) {
        return Promise.resolve([]);
      }
      return Promise.reject(new Error(err));
    }
  },

  /**
   * Create a new form
   *
   * TODO: Deprecate for saveSlider
   */
  async create({ state, dispatch }) {
    // as we are creating, remove the ID key
    // TODO: Better error handling / validation
    const { id, ...payload } = state.currentBanner;
    let response;

    try {
      response = await api().post("/homepage/banner", { banner: payload });
      await dispatch(
        "notifications/create",
        {
          body: "Banner has been created",
          type: "success",
        },
        { root: true }
      );
      return Promise.resolve(response);
    } catch (err) {
      console.log("TCL: create -> err", { ...err });
      return Promise.reject(response);
    }
  },

  /**
   * Update a form
   *
   * TODO: Deprecate for updateSlider
   */
  async update({ state, dispatch }) {
    // as we are creating, remove the ID key
    // TODO: Better error handling / validation
    const { id, ...payload } = state.currentBanner;
    let response;

    try {
      response = await api().post(`/homepage/banner/${id}`, {
        banner: payload,
      });
      dispatch(
        "notifications/create",
        {
          body: "Banner has been updated",
          type: "success",
        },
        { root: true }
      );
      return Promise.resolve(response);
    } catch (err) {
      return Promise.reject(response);
    }
  },

  /**
   * Delete a banner
   *
   * TODO: Deprecate for deleteSlider
   */
  async delete({ dispatch }, id) {
    let response;

    try {
      response = await api().delete(`/homepage/banner/${id}`);
      await dispatch("list", { Flat: true });
      dispatch(
        "notifications/create",
        {
          body: "Banner has been deleted",
          type: "success",
        },
        { root: true }
      );
      return Promise.resolve(response);
    } catch (err) {
      dispatch(
        "notifications/create",
        {
          body: "Banner has not been deleted",
          type: "error",
        },
        { root: true }
      );
      return Promise.reject(err);
    }
  },

  /**
   * Set the currentBanner to its initial state
   *
   * TODO: Deprecate for getBaseSlider
   */
  getBaseBanner({ commit }) {
    return new Promise((resolve, reject) => {
      commit(types.SET_BANNER, { ...initialBannerState.banners }[0]);
      resolve({ ...initialBannerState.banners }[0]);
    });
  },
  getBaseSlider({ commit }) {
    return new Promise((resolve, reject) => {
      const initialState = {
        name: null,
        status: "inactive",
        banners: [
          {
            id: null,
            title: null,
            description: null,
            button_text: null,
            link_url: null,
            resource: null,
            resource_id: null,
            resource_title: null,
            file_id: null,
            duration: null,
            video_id: null,
            video_url: null,
            resource_obj: null,
          },
        ],
      };
      commit(types.SET_BANNER_SET_EDIT, initialState);
      resolve(initialState);
    });
  },

  /**
   * Set a banner status
   *
   * TODO: Deprecate for setStatusSlider
   */
  async setStatus({ state, dispatch }, options) {
    let id;
    if (!options.id) {
      id = state.currentBanner;
    } else {
      id = options.id;
    }
    const endpoint =
      options.status === "active"
        ? `/homepage/banner/${id}/activate`
        : `/homepage/banner/${id}/deactivate`;
    let response;

    try {
      response = await api().post(endpoint);
      await dispatch("list", { flat: true });
      // set a notification
      await dispatch(
        "notifications/create",
        {
          body: "Status has been updated",
          type: "success",
        },
        { root: true }
      );

      return Promise.resolve(response);
    } catch (err) {
      return Promise.reject(new Error(err));
    }
  },

  /**
   * Load a banner
   *
   * TODO: Deprecate for loadSlider
   */
  async load({ commit }, params) {
    let response;
    const { bannerId } = params;

    const saveInState = params.saveInState ? params.saveInState : true;

    try {
      response = await api().get(`/homepage/banner/${bannerId}`);
      const item = response.data.data.banner[0];
      console.log("TCL: load -> item", item);
      // we need to strip down the object
      // can we convert to new style?
      let returnObj = {};
      Object.keys(initialBannerState).forEach((key) => {
        returnObj[key] = item[key];
      });
      if (!returnObj.banners || returnObj.banners.length == 0) {
        returnObj.banners = [item];
      }
      if (
        item.resource &&
        item.resource.self &&
        returnObj.banners.length == 1
      ) {
        returnObj.banners[0].resource_id = item.resource.id;
        returnObj.banners[0].resource_title = item.resource.title;
        const itemType = item.resource.self.split("/");
        // returnObj.resource = `${itemType[0]}_${itemType[1]}`
      }

      if (item.file) {
        returnObj.banners[0].file_id = item.file.id;
      }

      if (saveInState) {
        commit(types.SET_BANNER, returnObj);
        commit(types.SET_BANNER_SET, returnObj);
      }
      console.log(
        "🚀 ~ file: actions.js ~ line 272 ~ load ~ returnObj",
        returnObj
      );
      return Promise.resolve(returnObj);
    } catch (err) {
      console.log("TCL:  ~ file: actions.js ~ line 271 ~ load ~ err", err);
      return Promise.reject(response);
    }
  },

  async listSliders({ commit, state }, options) {
    let response;

    // TODO: Should always be flat really
    let endpoint = "/homepage/sliders/flat";

    const page = options && options.page ? options.page : 1;
    const size = state.pagination.per_page;
    let from = size * page - size;

    if (!from) {
      from = 0;
    }

    const filter = {
      size,
      from,
      sort: [
        {
          [state.sortBy.field]: {
            order: state.sortBy.direction,
          },
        },
      ],
      query: {
        bool: {
          must: [
            {
              bool: {
                should: [
                  {
                    match: {
                      name: {
                        query: state.filters.searchQuery,
                        operator: "and",
                        zero_terms_query: "all",
                        fuzziness: "AUTO",
                      },
                    },
                  },
                  {
                    match_phrase_prefix: {
                      name: {
                        query: state.filters.searchQuery,
                        slop: 50,
                      },
                    },
                  },
                ],
              },
            },
          ],
        },
      },
    };

    try {
      response = await api().post(endpoint, { filter });

      if (response) {
        const { slider } = response.data.data;

        /**
         * Need to alter objects for policies/forms/eforms/files
         */

        commit("SET_FILTER_TOTAL", response.data.meta.filter_total);
        commit("SET_CURRENT_PAGE", page);
        commit(types.LIST_BANNERS, slider);
        return Promise.resolve(slider);
      } else {
        commit(types.LIST_BANNERS, []);
        return Promise.reject(new Error(err));
      }
    } catch (err) {
      if (err.response.status === 404 && err.response.data.data.length === 0) {
        return Promise.resolve([]);
      }
      return Promise.reject(new Error(err));
    }
  },

  async loadSlider({ commit, state }, params) {
    let response;
    const { bannerId } = params;

    const saveInState = params.saveInState ? params.saveInState : false;

    try {
      response = await api().get(`/homepage/slider/${bannerId}`);
      const data = response.data.data.slider[0];

      let formattedBanners;

      if (data.banners && data.banners.length > 0) {

      formattedBanners = data.banners.map((item) => {
        let returnObj = {};
        Object.keys(initialBannerState.banners[0]).forEach((key) => {
          returnObj[key] = item[key];
        });
        if (item.video) {
          returnObj.video_id = item.video;
        }
        if (item.resource) {
          returnObj.resource_obj = item.resource;
        }
        if (item.resource && item.resource.self) {
          returnObj.resource_id = item.resource.id;
          returnObj.resource_title = item.resource.title;
          const itemType = item.resource.self.split("/");
          try {
            console.log('Item Type', itemType);
            returnObj.resource = state.resource_types.filter((resourceType) => {
              return resourceType.self == itemType[0];
            })[0].id;
            console.log('Item Resource Type', returnObj.resource);
          } catch(err) {
            returnObj.resource = item.resource;
            console.log('Item Resource Type Filter error', err);
          }
        }

        if (item.file) {
          returnObj.file_id = item.file.id;
        }

        return returnObj;
      });
    }

      const newObj = { ...data, banners: formattedBanners };
      if (saveInState) {
        commit(types.SET_BANNER_SET_EDIT, newObj);
      }
      console.log("🚀 ~ file: actions.js ~ line 272 ~ load ~ newObj", newObj);
      return Promise.resolve(newObj);
    } catch (err) {
      console.log("TCL:  ~ file: actions.js ~ line 271 ~ load ~ err", err);
      return Promise.reject(response);
    }
  },

  /**
   * Query an index for results
   */
  async resourceSearch(context, options) {
    let { index, term } = options;
    let response;

    /**
     * Handle search results for:
     * [x] Page
     * [x] Form
     * [x] Policy
     * [x] News
     * [x] Question
     * [x] EForm
     * [x] Event
     * [x] File
     */

    let queryField = "title";
    let isDoc = false;
    let type;

    if (index.includes("page")) {
      type = "page";
    }

    if (index.includes("news")) {
      type = "article";
    }

    if (index.includes("event")) {
      type = "event";
    }

    if (index.includes("question")) {
      type = "question";
    }

    if (
      index.includes("formmanagement") &&
      !index.includes("eformmanagement")
    ) {
      queryField = "form_title";
      index = "/formmanagement/forms";
      isDoc = true;
      type = "form";
    }

    if (index.includes("eformmanagement")) {
      queryField = "eform_title";
      isDoc = true;
      type = "eform";
    }

    if (index.includes("policymanagement")) {
      queryField = "policy_title";
      index = "/policymanagement/policies";
      isDoc = true;
      type = "policy";
    }
    if (index.includes("eformmanagement")) {
      queryField = "eform_title";
      type = "eform";
    }

    if (index.includes("file")) {
      queryField = "name";
      index = "/files/flat";
      type = "file";
    }
    if (index.includes("survey")) {
      queryField = "survey_title";
      type = "survey";
      isDoc = true;
    }

    let query = {
      bool: {
        must: [
          {
            bool: {
              should: [
                {
                  match: {
                    [queryField]: {
                      query: term,
                      operator: "and",
                      zero_terms_query: "all",
                      fuzziness: "AUTO",
                    },
                  },
                },
                {
                  match_phrase_prefix: {
                    [queryField]: {
                      query: term,
                      slop: 50,
                    },
                  },
                },
              ],
            },
          },
        ],
      },
    };

    if (index.includes("file")) {
      /**
       * Files need a specific query
       */
      query.bool.must_not = [
        {
          terms: {
            resource_types: ["policy", "forms"],
          },
        },
      ];
    }

    try {
      response = await api().post(index, {
        filter: { query: query, size: 10 },
      });
      let formattedResults = [];
      /**
       * If we are a document we need to get the title from the current version
       */
      if (isDoc) {
        formattedResults = response.data.data[type].map((item) => {
          const title = item.current_version.title;
          return { ...item, [queryField]: title };
        });
      } else {
        formattedResults = response.data.data[type];
      }

      return Promise.resolve({ response: formattedResults, queryField });
    } catch (err) {
      return Promise.reject(new Error(err));
    }
  },

  async saveSlider({ dispatch }, slider) {
    const payload = {
      slider,
    };

    let resp;

    try {
      resp = await api().post("/homepage/slider", payload);
      dispatch(
        "notifications/create",
        {
          body: "The slider has been created",
          type: "success",
        },
        { root: true }
      );
      return Promise.resolve(resp);
    } catch (err) {
      dispatch(
        "notifications/create",
        {
          body: `There was an error creating the slider - please try again ${err}`,
          type: "error",
        },
        { root: true }
      );
      return Promise.reject(new Error(err));
    }
  },
  async updateSlider({ state, dispatch }) {
    const { id, ...payload } = state.currentBannerSetEdit;

    let response;

    try {
      response = await api().post(`/homepage/slider/${id}`, {
        slider: payload,
      });
      dispatch(
        "notifications/create",
        {
          body: "Slider has been updated",
          type: "success",
        },
        { root: true }
      );
      return Promise.resolve(response);
    } catch (err) {
      dispatch(
        "notifications/create",
        {
          body: `There was an error updating the slider - please try again ${err}`,
          type: "error",
        },
        { root: true }
      );
      return Promise.reject(response);
    }
  },

  async loadActiveSlider({ commit }) {
    let resp;
    const bannerStorage = localStorage.getItem("mft_store_getFixedBanner");
    let slider;
    try {
      if (
        !bannerStorage ||
        JSON.parse(bannerStorage).timestamp < new Date().getTime() - (0.5 * 60 * 60 * 10)
      ) {
        resp = await api().get("/homepage/currentslider");
        // load images for each slider

        slider = resp.data.data.slider[0];
        slider.timestamp = new Date().getTime();
        localStorage.setItem(
          "mft_store_getFixedBanner",
          JSON.stringify(slider)
        );
      } else {
        slider = JSON.parse(localStorage.getItem("mft_store_getFixedBanner"));
      }
      commit(types.SET_BANNER_SET, slider);
      return Promise.resolve(slider);
    } catch (err) {
      return Promise.reject(new Error(err));
    }
  },

  async setStatusSlider({ state, dispatch }, options) {
    console.log("🚀 ~ file: actions.js ~ line 695 ~ setStatusSlider ~ options", options)
    let id;
    if (!options.id) {
      id = state.currentBannerSet.id;
    } else {
      id = options.id;
    }
    const endpoint =
    options.status === "active"
    ? `/homepage/slider/${id}/activate`
    : `/homepage/slider/${id}/deactivate`;
    let response;
    console.log("🚀 ~ file: actions.js ~ line 703 ~ setStatusSlider ~ endpoint", endpoint)

    try {
      response = await api().post(endpoint);
      await dispatch("listSliders", { flat: true });
      // set a notification
      await dispatch(
        "notifications/create",
        {
          body: "Status has been updated",
          type: "success",
        },
        { root: true }
      );

      return Promise.resolve(response);
    } catch (err) {
      return Promise.reject(new Error(err));
    }
  },
  async deleteSlider({ dispatch }, id) {
    let response;

    try {
      response = await api().delete(`/homepage/slider/${id}`);
      await dispatch("listSliders", { Flat: true });
      dispatch(
        "notifications/create",
        {
          body: "Banner has been deleted",
          type: "success",
        },
        { root: true }
      );
      return Promise.resolve(response);
    } catch (err) {
      dispatch(
        "notifications/create",
        {
          body: "Banner has not been deleted",
          type: "error",
        },
        { root: true }
      );
      return Promise.reject(err);
    }
  },

  async savePreview({ commit }, payload) {
    commit(types.SET_PREVIEW, payload);
    return Promise.resolve();
  },
};
